import React from "react";
import {
  Box,
  Group,
  TextInput,
  Checkbox,
  Card,
  Input,
} from "@mantine/core";
import { useForceUpdate } from "@mantine/hooks";

const fieldSx = { flex: "1 1 120px", minWidth: 120 };

const ContactInfoRow = ({ item, form, name }) => {
  const forceUpdate = useForceUpdate();

  return (
    <Card pt={0}>
      <Group
        mt="sm"
        spacing="sm"
        align="flex-end"
        noWrap
        sx={{ overflowX: "auto" }}
      >
        <TextInput
          size="xs"
          placeholder="Name"
          label="Name"
          value={item.content["name"]}
          sx={fieldSx}
          onChange={(e) => {
            item.content["name"] = e.target.value;
            forceUpdate();
          }}
        />
        <TextInput
          size="xs"
          placeholder="Department"
          label="Department"
          value={item.content["department"]}
          sx={{ flex: "0 1 100px", minWidth: 100, maxWidth: 120 }}
          onChange={(e) => {
            item.content["department"] = e.target.value;
            forceUpdate();
          }}
        />
        <TextInput
          size="xs"
          placeholder="Title"
          label="Title"
          sx={{ flex: "0 1 90px", minWidth: 90, maxWidth: 110 }}
          value={item.content["title"]}
          onChange={(e) => {
            item.content["title"] = e.target.value;
            forceUpdate();
          }}
        />
        <TextInput
          size="xs"
          placeholder="Phone"
          label="Phone"
          value={item.content["phone"]}
          sx={{ flex: "1 1 150px", minWidth: 150 }}
          onChange={(e) => {
            item.content["phone"] = e.target.value;
            forceUpdate();
          }}
        />
        <TextInput
          size="xs"
          placeholder="Email"
          label="Email"
          sx={{ flex: "2 1 240px", minWidth: 240 }}
          value={item.content["email"]}
          onChange={(e) => {
            item.content["email"] = e.target.value;
            forceUpdate();
          }}
        />
        <Box sx={{ flexShrink: 0, width: 72 }}>
          <Input.Wrapper
            label="Public"
            size="xs"
            labelProps={{ sx: { whiteSpace: "nowrap" } }}
          >
            <Checkbox
              size="xs"
              checked={!!item.content["isPublic"]}
              onChange={(e) => {
                item.content["isPublic"] = e.target.checked;
                forceUpdate();
              }}
            />
          </Input.Wrapper>
        </Box>
      </Group>
    </Card>
  );
};

export default ContactInfoRow;
